module.exports = __webpack_public_path__ + "img/Zech Medley.91810752.png";